// extracted by mini-css-extract-plugin
export default {"menuCard":"MenuCard_menuCard__gg4X4","cardContent":"MenuCard_cardContent__hXnHL","icon":"MenuCard_icon__nZ4E2","title":"MenuCard_title__zcnFy","arrow":"MenuCard_arrow__3S4Ur"};